import { render, staticRenderFns } from "./TabActualPrice.vue?vue&type=template&id=c732d084&scoped=true"
import script from "./TabActualPrice.vue?vue&type=script&lang=js"
export * from "./TabActualPrice.vue?vue&type=script&lang=js"
import style0 from "./TabActualPrice.vue?vue&type=style&index=0&id=c732d084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c732d084",
  null
  
)

export default component.exports